import React, { useEffect, useState } from "react";
import { Table, TableColumn } from "../../../components/table";
import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import IconMdi from "@mdi/react";
import { mdiPencilCircle, mdiDelete } from "@mdi/js";
import EmptyModel from "../../../components/modal/emptyModal";
import Input from "../../../components/textfield/input";
import Select from "../../../components/select/selectField";
import { Modal, message } from "antd";
import { Icon } from "@iconify/react";
import axios from "axios";
const OtherUnit = () => {
  const { confirm } = Modal;
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [data, setData] = useState<any>([]);
  const [dataCreate, setDataCreate] = useState<any>({});
  const [dataSelect, setDataSelect] = useState<any>({});
  const [branch, setBranch] = useState<any>([]);
  const [units, setUnits] = useState<any>([]);
  const columns = [
    {
      title: "ลำดับ<br/>No.",
      align: "center",
    },
    {
      title: "หน่วย<br/>Unit",
      align: "center",
    },
    {
      title: "แก้ไข<br/>Edit",
      align: "center",
    },
    {
      title: "ลบ<br/>Delete",
      align: "center",
    },
  ];

  function onClose() {
    setIsOpen(false);
    setIsOpenEdit(false);
  }
  const getUnits = () => {
    axios.get(`/stock-product-units`).then((res) => {
      setUnits(res?.data)
    });
  };
  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        removeData(id);
      },
      width: "fit-content",
    });
  }

  useEffect(() => {
    getBranch();
    getUnits();
  }, []);


  const CreateData = () => {
    axios.post(`/stock-product-units`, dataCreate).then((res) => {
      setDataCreate({});
      onClose();
      getUnits();
    }).catch((err) =>{
      console.log(err)
      message.warning(err.response.data.error.message);
    });
  }
  const removeData = (id: number) => {
    axios.delete(`/stock-product-units/${id}`).then((res) => {
      getUnits();
    });
  }
  const updateData = (id: number) => {
    axios.patch(`/stock-product-units/${id}`, dataSelect).then((res) => {
      onClose();
      getUnits();
    });
  }
  const getBranch = () => {
    axios.get(`/branches`).then((res) => {
      setBranch(res?.data?.data.map((item: any) => {
        return {
          value: item._id,
          name: item.name
        }
      }));
    });
  }
  return (
    <div>
      <HeaderBar title="UNIT" />
      <EmptyModel show={isOpen} onClose={onClose} setStyle={{height : 'auto'}}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >
          <h4>สร้างหน่วย/Create Unit</h4>
          <div className="row justify-center  mt-20">
            <Input
              className="col-12"
              title="ชื่อหน่วย/Name Unit"
              placeholder=""
              value={dataCreate?.name}
              onChange={(e) => {
                setDataCreate({ ...dataCreate, name: e.target.value })
              }}
            />
          </div>
          <div className="justify-center mt-20">
            <MainButton
              className="mg-10"
              background="#E76464"
              title="ยกเลิก/Cancel"
              onClick={() => {
                setIsOpen(false);
                setDataCreate({
                  name : ""
                });
              }}
            />
            <MainButton
              className="mg-10"
              title="บันทึกข้อมูล/Submit"
              onClick={() => CreateData()}
            />
          </div>
        </div>
      </EmptyModel>
      <EmptyModel show={isOpenEdit} onClose={onClose}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >
          <h4>แก้ไขหน่วย/Edit Unit</h4>

          <div className="row justify-center  mt-20">
            <Input
              className="col-12"
              title="ชื่อหน่วย/Name Unit"
              placeholder=""
              value={dataSelect?.name}
              onChange={(e) => {
                setDataSelect({ ...dataSelect, name: e.target.value })
              }}
            />
          </div>
          <div className="justify-center mt-20">
            <MainButton
              className="mg-10"
              background="#E76464"
              title="ยกเลิก/Cancel"
              onClick={() => {
                setIsOpen(false);
              }}
            />
            <MainButton
              className="mg-10"
              title="บันทึกข้อมูล/Submit"
              onClick={() => updateData(dataSelect?._id)}
            />
          </div>
        </div>
      </EmptyModel>
      <div style={{ padding: "10px 40px" }}>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "10px" }}
        >
          <MainButton
            title="Create Unit"
            onClick={() => {
              setIsOpen(true);
            }}
          >
            <Icon
              icon="akar-icons:plus"
              width="24"
              height="24"
              color="white"
            />
          </MainButton>
        </div>
        <div style={{ marginTop: "10px" }}>
          <Table header={columns}>
            {units?.data?.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="25%">{item.name}</TableColumn>
                <TableColumn width="3%" align="center">
                  <div
                    onClick={() => {
                      setIsOpenEdit(true);
                      setDataSelect(item);
                    }}
                  >
                    <IconMdi path={mdiPencilCircle} size="24" color="#5BAEA9" />
                  </div>
                </TableColumn>
                <TableColumn
                  width="3%"
                  align="center"
                  onClick={() => {
                    showDeleteConfirm(item._id, item.name);
                  }}
                >
                  <IconMdi path={mdiDelete} size="24" color="#FF6760"></IconMdi>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default OtherUnit;
